export default "__VITE_ASSET__a01b396c__"